import { Component, OnInit, ViewChild } from '@angular/core';
import { process, SortDescriptor } from '@progress/kendo-data-query';
import { DataBindingDirective } from '@progress/kendo-angular-grid';
import { HttpErrorResponse } from '@angular/common/http';
import { Router } from '@angular/router';
import { DisplayNotificationService } from 'src/app/shared/services/common/notification.service';
import { DocumentService } from 'src/app/shared/services/documents/document.service';
import { AuthService } from 'src/app/shared/services/auth/auth.service';

@Component({
  selector: 'app-employer-document-history',
  templateUrl: './employer-document-history.component.html',
  styleUrls: ['./employer-document-history.component.css']
})
export class EmployerDocumentHistoryComponent implements OnInit {
  @ViewChild(DataBindingDirective, { static: true }) dataBinding: DataBindingDirective;
  public gridData: any;
  public gridView: any;
  public sort: SortDescriptor[] = [{
    field: 'modifiedDate',
    dir: 'desc'
  }];

  constructor(
    private router: Router,
    private authService: AuthService,
    private documentService: DocumentService,
    private notificationService: DisplayNotificationService) { }

  ngOnInit() {
    if (this.authService.isLoggedIn) {
      this.authService.loggedInChecker(this.authService.isLoggedIn);
    }
    this.notificationService.setUpLoading(true);
    this.loadMyDocuments();
  }

  loadMyDocuments() {
    this.documentService.getMyDocuments().subscribe((data: any) => {
      if (data.statusCode === 200 && data.result) {
        this.gridData = data.result;
        this.gridView = this.gridData;
      } else if (data.statusCode === 403) {
        this.router.navigate(['/forbidden']);
      } else {
        this.notificationService.setErrorNotification();
      }
      this.notificationService.setUpLoading(false);
    }, (error: HttpErrorResponse) => {
      console.log(error);
      this.notificationService.setUpLoading(false);
      this.notificationService.setErrorNotification();
    });
  }

  viewDoc(data: any) {
    this.documentService.getMyDocument(data.uniqueId, data.docName).subscribe(() => {
      data.isClicked = !data.isClicked;
    }, (error: HttpErrorResponse) => {
      console.log(error);
      data.isClicked = !data.isClicked;
      this.notificationService.setErrorNotification();
    });
  }

  onFilter(inputValue: string): void {
    this.gridView = process(this.gridData, {
      filter: {
        logic: 'or',
        filters: [
          {
            field: 'docName',
            operator: 'contains',
            value: inputValue
          },
          {
            field: 'title',
            operator: 'contains',
            value: inputValue
          },
          {
            field: 'docCategory',
            operator: 'contains',
            value: inputValue
          },
          {
            field: 'docType',
            operator: 'contains',
            value: inputValue
          },
          {
            field: 'modifiedDate',
            operator: 'contains',
            value: inputValue
          }
        ],
      }
    }).data;
    this.dataBinding.skip = 0;
  }
}
